module.exports = __webpack_public_path__ + "img/ic_drop.b887f508.svg";